import { http } from 'src/services/RomanticAI/http';
import * as types from './types';

export * from './types';

export const getGift = () => http.get<types.GetGiftData>('/gift');

export const postGift = ({ gift_id, bot_id, ...data }: types.IPostGiftParams) =>
  http.post<types.IPostGiftData>(`/gift/${gift_id}/bot/${bot_id}`, data);
